@if (!embedded) {
  <div mat-dialog-title>
    <h2>{{'group-management.join_class_title' | translate}}</h2>
    <button class="close"
      (click)="dialogRef.close()"
      aria-label="Close dialog">
      <mat-icon svgIcon="cross"></mat-icon>
    </button>
  </div>
}

@if (!embedded) {
  <mat-dialog-content>
    @if (!errorMessage) {
      <h3>{{ title | translate}}</h3>
    }
    @if (!finish && !errorMessage) {
      <div
        class="mb-24"
        fxLayout="row"
        fxLayoutAlign="start start">
        <mat-form-field appearance="fill" fxFlex>
          <mat-label>{{'group-management.join_class_title' | translate}}</mat-label>
          <mat-select [(value)]="selectedGroup">
            @for (group of groups; track group) {
              <mat-option [value]="group">{{ group.get('label') }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
    @if (errorMessage) {
      <div>{{ errorMessage | translate }}</div>
    }
  </mat-dialog-content>
}

@if (!embedded) {
  <mat-dialog-actions>
    @if (errorMessage === '') {
      <button
        (click)="joinClass()"
        mat-raised-button
      class="mat-accent">{{'group-management.join_class_confirm' | translate}}</button>
    }
    @if (errorMessage === '') {
      <button
        (click)="reset()"
        mat-raised-button
      class="mat-accent">{{'generic.cancel' | translate}}</button>
    }
  </mat-dialog-actions>
}

@if (embedded) {
  <div class="embed-container">
    @if (!errorMessage) {
      <mat-form-field appearance="fill" fxFlex>
        <mat-label>{{'group-management.join_class_title' | translate}}</mat-label>
        <mat-select [(value)]="selectedGroup">
          @for (group of groups; track group) {
            <mat-option [value]="group">{{ group.get('label') }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    @if (errorMessage) {
      <div>{{ errorMessage | translate }}</div>
    }
    @if (errorMessage === '') {
      <button
        (click)="joinClass()"
        mat-raised-button
      class="mat-accent">{{'group-management.join_class_confirm' | translate}}</button>
    }
  </div>
}